import React, { useEffect, useState } from 'react';
import FormComponent from './form';
import PropTypes from "prop-types"
import { withTranslation } from 'react-i18next';
import withRouter from "components/Common/withRouter"
import { Container } from 'reactstrap';
import { MetaTags } from 'react-meta-tags';
import { Spin } from 'antd';
import { GET_CustomerOrgs } from 'helpers/url_helper';
import { post } from 'helpers/api_helper';
import { useNavigate } from 'react-router-dom';

const CustomerPaymentCreate = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [orgsOptions, setOrgsOptions] = useState('')
  const navigate = useNavigate()

  const getOrgList = async () => {
    setIsLoading(true)
    await post(GET_CustomerOrgs, { organization_id: 1 })
      .then(res => {
        if (res?.status == 200 && res?.data.length > 0) {
          let NewOptions = []
          res?.data?.map(item =>
            NewOptions.push({
              label: item?.display_name,
              value: item?.id,
            })
          )
          setOrgsOptions(NewOptions)
        } else {
          setOrgsOptions([])
        }
        setIsLoading(false)
      })
      .catch(error => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    getOrgList()
  }, [])


  return (
    <div>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <div className="page-content">
          <MetaTags>
            <title>Add Shipment | Katlax OMS</title>
          </MetaTags>
          <Container fluid>
            <div className='mt-4'>
              <FormComponent
                setIsLoading={setIsLoading}
                orgsOptions={orgsOptions}
              />
            </div>
          </Container>
        </div>
      </Spin>
    </div>
  );
};

CustomerPaymentCreate.propTypes = {
  t: PropTypes.any,
}
export default withRouter(withTranslation()(CustomerPaymentCreate))
